import { notEmpty } from '../../utils/validator'
export default {
  className: 'settings',
  tableSize: 'small',
  fields: [
    {
      name: 'label',
      note: '名称',
      validators: [
        notEmpty()
      ]
    },
    {
      name: 'value',
      validators: [
        notEmpty()
      ]
    }
  ],
  hooks: {
    beforeFetch ({ where }) {
      where.isPublic = true
    },
    beforeSave ({ data }) {
      data.isPublic = true
    }
  },
  action: {
    create: false,
    export: false,
    delete: false
  }
}
